document.addEventListener("DOMContentLoaded", function () {
  const targets = document.querySelectorAll(".fadein");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  }, {
    threshold: 0.1  // 10% 見えたら発火
  });

  targets.forEach((el) => observer.observe(el));
});